import { render, staticRenderFns } from "./header-pos-session-area.vue?vue&type=template&id=ec46afe0&scoped=true&"
import script from "./header-pos-session-area.vue?vue&type=script&lang=ts&"
export * from "./header-pos-session-area.vue?vue&type=script&lang=ts&"
import style0 from "./header-pos-session-area.vue?vue&type=style&index=0&id=ec46afe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec46afe0",
  null
  
)

export default component.exports